import React,{useState} from "react";
import Footer from "./footer";
import Header from "./header";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Link} from "react-router-dom"

export default function Contact() {
      const intialState ={name:"",email:"",subject:"",message:"",phone:""}
  const [contacts, setContacts] = useState(intialState);
  const [errors, setErrors] = useState({});
      const handleChange = ({ target }) => {
    let { name, value } = target;
    setContacts({ ...contacts, [name]: value });
  };
  const validate = (values) => {
  const newErrors = {};
  if (!values.name.trim()) {
    newErrors.name = "Name is required";
  }
  if (!values.email) {
    newErrors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    newErrors.email = "Email is invalid";
  }
  if (!values.subject.trim()) {
    newErrors.subject = "Subject is required";
  }
  if (!values.phone) {
    newErrors.phone = "Phone number is required";
  } else if (!/^[0-9]{10}$/.test(values.phone)) {
    newErrors.phone = "Phone must be 10 digits";
  }
  if (!values.message.trim()) {
    newErrors.message = "Message is required";
  }
  return newErrors;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
const formErrors = validate(contacts);

  if (Object.keys(formErrors).length > 0) {
    setErrors(formErrors);
    return; // stop submit if errors exist
  }
  setErrors({});

    try {
      await axios.post(
        "https://sunrise-backend.sunrisemeditechsystems.com/api/contacts/create",
        contacts
      );
      setContacts(intialState);
      toast.success("Contacts create successfully!", {
        position: "top-right",
        autoClose: 3000, // 3 seconds
      });
    } catch (error) {
      console.error("❌ Error:", error);
    }
  };
    return(
        <>
      <div className="color-scheme-wrap active">
        <button className="switchIcon"><i className="fa-solid fa-palette"></i></button>
        <h4 className="color-scheme-wrap-title"><i className="far fa-palette me-2"></i>Style Swicher</h4>
        <div className="color-switch-btns">
            <button data-color="#3E66F3"><i className="fa-solid fa-droplet"></i></button>
            <button data-color="#684DF4"><i className="fa-solid fa-droplet"></i></button>
            <button data-color="#008080"><i className="fa-solid fa-droplet"></i></button>
            <button data-color="#323F7C"><i className="fa-solid fa-droplet"></i></button>
            <button data-color="#FC3737"><i className="fa-solid fa-droplet"></i></button>
            <button data-color="#8a2be2"><i className="fa-solid fa-droplet"></i></button>
        </div>
        <Link to="https://themeforest.net/user/themeholy" className="th-btn text-center w-100"><i className="fa fa-shopping-cart me-2"></i> Purchase</Link>
    </div> 
    {/* Preloader */}
    {/* <div className="preloader ">
        <button className="th-btn preloaderCls">Cancel Preloader </button>
        <div className="preloader-inner">
            <img src="assets/img/logo.svg" alt="img"/>
            <div className="heart-rate">
                <img src="assets/img/shape/preloader.svg" alt=""/>

                <div className="fade-in"></div>

                <div className="fade-out"></div>
            </div>
        </div>
    </div> */}
    {/* Sidemenu */}
    <div className="sidemenu-wrapper shopping-cart ">
        <div className="sidemenu-content">
            <button className="closeButton sideMenuCls"><i className="far fa-times"></i></button>
            <div className="widget woocommerce widget_shopping_cart">
                <h3 className="widget_title">Shopping cart</h3>
                <div className="widget_shopping_cart_content">
                    <ul className="woocommerce-mini-cart cart_list product_list_widget ">
                        <li className="woocommerce-mini-cart-item mini_cart_item">
                            <Link to="#" className="remove remove_from_cart_button"><i className="far fa-times"></i></Link>
                            <Link to="#"><img src="assets/img/product/product_thumb_1_1.jpg" alt="Cart Image1"/>Puregen Labs Meclizine</Link>
                            <span className="quantity">1 ×
                                <span className="woocommerce-Price-amount amount">
                                    <span className="woocommerce-Price-currencySymbol">$</span>$55.00</span>
                            </span>
                        </li>
                        <li className="woocommerce-mini-cart-item mini_cart_item">
                            <Link to="#" className="remove remove_from_cart_button"><i className="far fa-times"></i></Link>
                            <Link to="#"><img src="assets/img/product/product_thumb_1_2.jpg" alt="Cart Image2"/>Pranarom Pure Essential Oil</Link>
                            <span className="quantity">1 ×
                                <span className="woocommerce-Price-amount amount">
                                    <span className="woocommerce-Price-currencySymbol">$</span>$15.00</span>
                            </span>
                        </li>
                        <li className="woocommerce-mini-cart-item mini_cart_item">
                            <Link to="#" className="remove remove_from_cart_button"><i className="far fa-times"></i></Link>
                            <Link to="#"><img src="assets/img/product/product_thumb_1_3.jpg" alt="Cart Image3"/>Pediatric Stethoscope</Link>
                            <span className="quantity">1 ×
                                <span className="woocommerce-Price-amount amount">
                                    <span className="woocommerce-Price-currencySymbol">$</span>$30.00</span>
                            </span>
                        </li>
                        <li className="woocommerce-mini-cart-item mini_cart_item">
                            <Link to="#" className="remove remove_from_cart_button"><i className="far fa-times"></i></Link>
                            <Link to="#"><img src="assets/img/product/product_thumb_1_4.jpg" alt="Cart Image4"/>Puregen Labs Allergy Relief</Link>
                            <span className="quantity">1 ×
                                <span className="woocommerce-Price-amount amount">
                                    <span className="woocommerce-Price-currencySymbol">$</span>$55.00</span>
                            </span>
                        </li>
                        <li className="woocommerce-mini-cart-item mini_cart_item">
                            <Link to="#" className="remove remove_from_cart_button"><i className="far fa-times"></i></Link>
                            <Link to="#"><img src="assets/img/product/product_thumb_1_5.jpg" alt="Cart Image5"/>Digital Thermometer</Link>
                            <span className="quantity">1 ×
                                <span className="woocommerce-Price-amount amount">
                                    <span className="woocommerce-Price-currencySymbol">$</span>$15.99</span>
                            </span>
                        </li>
                    </ul>
                    <p className="woocommerce-mini-cart__total total">
                        <strong>Subtotal:</strong>
                        <span className="woocommerce-Price-amount amount">
                            <span className="woocommerce-Price-currencySymbol">$</span>170.99</span>
                    </p>
                    <p className="woocommerce-mini-cart__buttons buttons btn-wrap">
                        <Link to="cart.html" className="th-btn wc-forward">View cart</Link>
                        <Link to="checkout.html" className="th-btn checkout wc-forward">Checkout</Link>
                    </p>
                </div>
            </div>
        </div>
    </div>
  {/* Sidemenu */}
    <div className="sidemenu-wrapper ">
        <div className="sidemenu-content">
            <button className="closeButton sideMenuCls"><i className="far fa-times"></i></button>
            <div className="widget footer-widget mb-0">
                <div className="th-widget-about">
                    <div className="about-logo">
                        <Link to="index.html"><img src="assets/img/logo.svg" alt="Medova "/></Link>
                    </div>
                    <p className="about-text">Medova is a convenience services to the adaptability, Spacious modern villa living room
                        with centrally placed swimming pool blending indooroutdoor</p>
                </div>
            </div>
            <div className="widget footer-widget">
                <h3 className="widget_title">Recent Posts</h3>
                <div className="recent-post-wrap">
                    <div className="recent-post">
                        <div className="media-img">
                            <Link to="blog-details.html"><img src="assets/img/blog/recent-post-1-1.jpg" alt="Blog Image1"/></Link>
                        </div>
                        <div className="media-body">
                            <div className="recent-post-meta">
                                <Link to="blog.html"><i className="fa-sharp fa-solid fa-calendar-days"></i>April 02,
                                    2025</Link>
                            </div>
                            <h4 className="post-title"><Link className="text-inherit" to="blog-details.html">Cometes contabesco audacia
                                    aeneus tui canonicus</Link></h4>
                        </div>
                    </div>
                    <div className="recent-post">
                        <div className="media-img">
                            <Link to="blog-details.html"><img src="assets/img/blog/recent-post-1-2.jpg" alt="Blog Image2"/></Link>
                        </div>
                        <div className="media-body">
                            <div className="recent-post-meta">
                                <Link to="blog.html"><i className="fa-sharp fa-solid fa-calendar-days"></i>April 25,
                                    2025</Link>
                            </div>
                            <h4 className="post-title"><Link className="text-inherit" to="blog-details.html">Cometes contabesco audacia
                                    aeneus tui canonicus</Link></h4>
                        </div>
                    </div>
                    <div className="recent-post">
                        <div className="media-img">
                            <Link to="blog-details.html"><img src="assets/img/blog/recent-post-1-3.jpg" alt="Blog Image3"/></Link>
                        </div>
                        <div className="media-body">
                            <div className="recent-post-meta">
                                <Link to="blog.html"><i className="fa-sharp fa-solid fa-calendar-days"></i>26 April,
                                    2025</Link>
                            </div>
                            <h4 className="post-title"><Link className="text-inherit" to="blog-details.html">Cometes contabesco audacia
                                    aeneus tui canonicus</Link></h4>

                        </div>
                    </div>
                    <div className="recent-post">
                        <div className="media-img">
                            <Link to="blog-details.html"><img src="assets/img/blog/recent-post-1-4.jpg" alt="Blog Image4"/></Link>
                        </div>
                        <div className="media-body">
                            <div className="recent-post-meta">
                                <Link to="blog.html"><i className="fa-sharp fa-solid fa-calendar-days"></i>27 April,
                                    2025</Link>
                            </div>
                            <h4 className="post-title"><Link className="text-inherit" to="blog-details.html">Cometes contabesco audacia
                                    aeneus tui canonicus</Link></h4>
                        </div>
                    </div>
                </div>
            </div>
            <div className="widget footer-widget">
                <h3 className="widget_title">Social Media:</h3>
                <div className="th-social">
                    <Link to="https://facebook.com"><i className="fab fa-facebook-f"></i></Link>
                    <Link to="https://twitter.com"><i className="fab fa-twitter"></i></Link>
                    <Link to="https://pinterest.com"><i className="fab fa-pinterest-p"></i></Link>
                    <Link to="https://linkedin.com"><i className="fab fa-linkedin-in"></i></Link>
                    <Link to="https://linkedin.com"><i className="fab fa-instagram"></i></Link>
                </div>
            </div>
        </div>
    </div>
    <div className="popup-search-box d-none d-lg-block">
        <button className="searchClose"><i className="fal fa-times"></i></button>
        <form action="#">
            <input type="text" placeholder="What are you looking for?"/>
            <button type="submit"><i className="fal fa-search"></i></button>
        </form>
    </div>
    {/* Mobile Menu */}
    <div className="th-menu-wrapper">
        <div className="th-menu-area text-center">
            <button className="th-menu-toggle"><i className="fal fa-times"></i></button>
            <div className="mobile-logo">
                <Link to="/"><img src="assets/img/logo.svg" alt="Medova "/></Link>
            </div>

            <div className="th-mobile-menu">
                <ul>
                    <li className="menu-item-has-children">
                        <Link to="/">Home</Link>
                        <ul className="sub-menu">
                            <li className="menu-item-has-children">
                                <Link to="#">Multipage</Link>
                                <ul>
                                    <li><Link to="/">Home Medical Clinic</Link></li>
                                    <li><Link to="home-medical-clinic-v2.html">Home Medical Clinic v2</Link></li>
                                    <li><Link to="home-dental-care.html">Home Dental Care</Link></li>
                                    <li><Link to="home-pediatric.html">Home Pediatric</Link></li>
                                    <li><Link to="home-cardiology.html">Home Cardiology</Link></li>
                                    <li><Link to="home-surgery.html">Home Surgery</Link></li>
                                    <li><Link to="home-physiotherapy.html">Home Physiotherapy</Link></li>
                                    <li><Link to="home-nutrition-diet.html">Home Nutrition Diet</Link></li>
                                    <li><Link to="home-optometrist.html">Home Optometrist</Link></li>
                                    <li><Link to="home-medical-shop.html">Home Medical Shop</Link></li>
                                </ul>
                            </li>
                            <li className="menu-item-has-children">
                                <Link to="#">Onepage</Link>
                                <ul>
                                    <li><Link to="home-medical-clinic-op.html">Home Medical Clinic</Link></li>
                                    <li><Link to="home-medical-clinic-v2-op.html">Home Medical Clinic v2</Link></li>
                                    <li><Link to="home-dental-care-op.html">Home Dental Care</Link></li>
                                    <li><Link to="home-pediatric-op.html">Home Pediatric</Link></li>
                                    <li><Link to="home-cardiology-op.html">Home Cardiology</Link></li>
                                    <li><Link to="home-surgery-op.html">Home Surgery</Link></li>
                                    <li><Link to="home-physiotherapy-op.html">Home Physiotherapy</Link></li>
                                    <li><Link to="home-nutrition-diet-op.html">Home Nutrition Diet</Link></li>
                                    <li><Link to="home-optometrist-op.html">Home Optometrist</Link></li>
                                    <li><Link to="home-medical-shop-op.html">Home Medical Shop</Link></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li><Link to="about.html">About Us</Link></li>
                    <li className="menu-item-has-children">
                        <Link to="#">Services</Link>
                        <ul className="sub-menu">
                            <li><Link to="service.html">Services</Link></li>
                            <li><Link to="service-details.html">Service Details</Link></li>
                        </ul>
                    </li>
                    <li className="menu-item-has-children">
                        <Link to="#">Pages</Link>
                        <ul className="sub-menu">
                            <li className="menu-item-has-children">
                                <Link to="#">Shop</Link>
                                <ul className="sub-menu">
                                    <li><Link to="shop.html">Shop</Link></li>
                                    <li><Link to="shop-details.html">Shop Details</Link></li>
                                    <li><Link to="cart.html">Cart Page</Link></li>
                                    <li><Link to="checkout.html">Checkout</Link></li>
                                    <li><Link to="wishlist.html">Wishlist</Link></li>
                                </ul>
                            </li>
                            <li><Link to="doctor.html">Doctors</Link></li>
                            <li><Link to="doctor-details.html">Doctors Details</Link></li>
                            <li><Link to="case-studies.html">Case Studies</Link></li>
                            <li><Link to="case-studies-details.html">Case Studies Details</Link></li>
                            <li><Link to="appointment.html">Appointment</Link></li>
                            <li><Link to="pricing.html">Price Table</Link></li>
                            <li><Link to="error.html">Error Page</Link></li>
                        </ul>
                    </li>
                    <li className="menu-item-has-children">
                        <Link to="#">Blog</Link>
                        <ul className="sub-menu">
                            <li>
                                <Link to="#">Blog Layout</Link>
                                <ul className="sub-menu">
                                    <li><Link to="blog.html">Blog</Link></li>
                                    <li><Link to="blog-grid.html">Blog Grid</Link></li>
                                    <li><Link to="blog-grid-sidebar.html">Blog Grid With Sidebar</Link></li>
                                    <li><Link to="blog-list.html">Blog List</Link></li>
                                </ul>
                            </li>
                            <li><Link to="blog-details.html">Blog Details</Link></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    {/* Header Area */}
    <Header/>
      {/* Breadcumb */}
    <div className="breadcumb-wrapper " data-bg-src="assets/img/bg/breadcumb-bg.jpg">
        <div className="container">
            <div className="breadcumb-content">
                <h1 className="breadcumb-title">Contact Us</h1>
                <ul className="breadcumb-menu">
                    <li><Link to="/">Home</Link></li>
                    <li>Contact Us</li>
                </ul>
            </div>
        </div>
    </div>
    {/* Contact Area    */}
    <div className="space overflow-hidden" id="contact-sec">
        <div className="container">
            <div className="row gy-4">
                <div className="col-xl-4">
                    <div className="contact-media-wrap">
                        <div className="contact-media">
                            <div className="icon-btn">
                                <i className="fa-solid fa-location-dot"></i>
                            </div>
                            <div className="media-body">
                                <h5 className="box-title">Our Current Location</h5>
                                <p className="box-text">Sardar Patel Ringroad, Zundal, Ahmedabad</p>
                            </div>
                        </div>
                        <div className="contact-media">
                            <div className="icon-btn">
                                <i className="fa-light fa-phone"></i>
                            </div>
                            <div className="media-body">
                                <h5 className="box-title">Phone Number</h5>
                                <p className="box-text">
                                    <Link to="tel:+00123666000666">+00 (123) 666 000 666</Link>
                                </p>
                            </div>
                        </div>
                        <div className="contact-media">
                            <div className="icon-btn">
                                <i className="fa-solid fa-envelope"></i>
                            </div>
                            <div className="media-body">
                                <h5 className="box-title">Email Address</h5>
                                <Link to="mailto: info@shreejimeditechsystems.com">info@shreejimeditechsystems.com</Link><br/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-8">
                    <form action="mail.php" method="POST" className="contact-form ajax-contact">
                        <h3 className="h4 mb-30 mt-n3">Do you have questions? Contact Us</h3>
                        <div className="row">
                            <div className="form-group col-md-6">
                                <input type="text" className="form-control" name="name" id="name" placeholder="Name" value={contacts.name} onChange={handleChange}/>
                                <i className="fal fa-user"></i>
                                 {errors.name && <small className="text-danger">{errors.name}</small>}
                            </div>
                            <div className="form-group col-md-6">
                                <input type="tel" className="form-control" name="phone" id="number" maxLength="10" placeholder="Phone Number" value={contacts.phone} onChange={handleChange}/>
                                <i className="fal fa-phone"></i>
                                  {errors.phone && <small className="text-danger">{errors.phone}</small>}
                            </div>
                            <div className="form-group col-12">
                                <input type="email" className="form-control" name="email" id="email" placeholder="e-mail address*" value={contacts.email}  onChange={handleChange}/>
                                <i className="fal fa-envelope"></i>
                                  {errors.email && <small className="text-danger">{errors.email}</small>}
                            </div>

                            <div className="form-group col-12">
                                <input type="text" className="form-control" name="subject" id="subject" placeholder="subject"  value={contacts.subject}  onChange={handleChange}/>
                                  {errors.subject && <small className="text-danger">{errors.subject}</small>}
                            </div>
                            <div className="form-group col-12">
                                <textarea name="message" id="message" cols="30" rows="3" className="form-control" placeholder="Your Message" value={contacts.message} onChange={handleChange}></textarea>
                                <i className="fal fa-comment"></i>
                                  {errors.message && <small className="text-danger">{errors.message}</small>}
                            </div>
                            <div className="form-btn mt-20 col-12">
                                <button className="th-btn" onClick={(e) => handleSubmit(e)}>Send Message</button>
                            </div>
                        </div>
                        <p className="form-messages mb-0 mt-3"></p>
                    </form>
                </div>
            </div>
        </div>
    </div>
    {/* Map Area  */}
    <div className="">
        <div className="contact-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3644.7310056272386!2d89.2286059153658!3d24.00527418490799!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39fe9b97badc6151%3A0x30b048c9fb2129bc!2sAngfuztheme!5e0!3m2!1sen!2sbd!4v1651028958211!5m2!1sen!2sbd" allowfullscreen="" loading="lazy" title="google map"></iframe>
            <div className="contact-icon">
                <img src="assets/img/icon/location-dot.svg" alt=""/>
            </div>
        </div>
    </div>

  {/* Footer Area */}
<Footer/>
    </>
    )
}